"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconChevronRight', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L8.59,8,5.29,4.71A1,1,0,0,1,6.71,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,6,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M11.58625,10 L6.29325,4.707 C5.90225,4.316 5.90225,3.684 6.29325,3.293 C6.48825,3.098 6.74425,3 7.00025,3 C7.25625,3 7.51225,3.098 7.70725,3.293 L13.70725,9.293 C14.09825,9.684 14.09825,10.316 13.70725,10.707 L7.70725,16.707 C7.31625,17.098 6.68425,17.098 6.29325,16.707 C5.90225,16.316 5.90225,15.684 6.29325,15.293 L11.58625,10 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _SVGIconWithSizes)));

exports.default = _default;